// import React from 'react';
// import { Route, Switch, Redirect } from 'react-router-dom';
import App from './app';

import Broadband from './broadband';
import Akasse from './akasse';
import CellphoneSubscription from './cellphone/subscription';
import CellphonePrepaid from './cellphone/prepaid';
import loan from './loan/loan';
import consumerloan from './loan/consumerloan';
// import quickloan from './loan/quickloan';
import Tv from './tv';
import Mbb from './mbb';
import Webhotel from './webhotel';
import Streaming from './streaming';
import Mealbox from './mealbox';
import Vpn from './vpn';

import Frontpage from './frontpage';
import About from './static-pages/about';
import Privacy from './static-pages/privacy-policy';
import Contact from './static-pages/contact';
import Terms from './static-pages/terms';

import NotFound from './static-pages/not-found';

export default [
  {
    component: App,
    routes: [
      { path: '/', component: Frontpage, exact: true },

      { path: '/om', component: About, exact: true },
      { path: '/privacy', component: Privacy, exact: true },
      { path: '/kontakt', component: Contact, exact: true },
      { path: '/terms', component: Terms, exact: true },

      { path: '/lån', component: loan, exact: true },
      { path: '/lån/:filter', component: loan, exact: true },
      { path: '/lan', component: loan, exact: true },
      { path: '/lan/:filter', component: loan, exact: true },
      { path: '/laan', component: loan, exact: true },
      { path: '/laan/:filter', component: loan, exact: true },

      { path: '/forbrugslån', component: consumerloan, exact: true },
      { path: '/forbrugslån/:filter', component: consumerloan, exact: true },
      { path: '/forbrugslaan', component: consumerloan, exact: true },
      { path: '/forbrugslaan/:filter', component: consumerloan, exact: true },

      // <Redirect exact from={encodeURI('/kviklån')} to={encodeURI('/lån')} />
      // <Redirect exact from="/kviklaan" to={encodeURI('/lån')} />

      { path: '/a-kasse', component: Akasse, exact: true },
      { path: '/a-kasse/:filter', component: Akasse, exact: true },
      { path: '/akasse', component: Akasse, exact: true },
      { path: '/akasse/:filter', component: Akasse, exact: true },

      { path: '/bredbånd', component: Broadband, exact: true },
      { path: '/bredbånd/:filter', component: Broadband, exact: true },
      { path: '/bredband', component: Broadband, exact: true },
      { path: '/bredband/:filter', component: Broadband, exact: true },
      { path: '/bredbaand', component: Broadband, exact: true },
      { path: '/bredbaand/:filter', component: Broadband, exact: true },

      { path: '/mobilabonnement', component: CellphoneSubscription, exact: true },
      { path: '/mobilabonnement/:filter', component: CellphoneSubscription, exact: true },

      { path: '/taletidskort', component: CellphonePrepaid, exact: true },

      { path: '/tv-udbydere', component: Tv, exact: true },
      { path: '/tv-udbydere/:filter', component: Tv, exact: true },
      { path: '/webhotel', component: Webhotel, exact: true },
      { path: '/webhotel/:filter', component: Webhotel, exact: true },
      { path: '/vpn', component: Vpn, exact: true },
      { path: '/vpn/:filter', component: Vpn, exact: true },
      { path: '/streaming', component: Streaming, exact: true },
      { path: '/streaming/:filter', component: Streaming, exact: true },

      
      { path: '/mealbox', component: Mealbox, exact: true },
      { path: '/mealbox/:filter', component: Mealbox, exact: true },
      { path: '/måltidskasse', component: Mealbox, exact: true },
      { path: '/måltidskasse/:filter', component: Mealbox, exact: true },
      { path: '/maaltidskasse', component: Mealbox, exact: true },
      { path: '/maaltidskasse/:filter', component: Mealbox, exact: true },

      { path: '/mobil-bredbånd', component: Mbb, exact: true },
      { path: '/mobil-bredbånd/:filter', component: Mbb, exact: true },
      { path: '/mobil-bredband', component: Mbb, exact: true },
      { path: '/mobil-bredband/:filter', component: Mbb, exact: true },
      { path: '/mobil-bredbaand', component: Mbb, exact: true },
      { path: '/mobil-bredbaand/:filter', component: Mbb, exact: true },

      { path: '/mobilbredbånd', component: Mbb, exact: true },
      { path: '/mobilbredbånd/:filter', component: Mbb, exact: true },
      { path: '/mobilbredband', component: Mbb, exact: true },
      { path: '/mobilbredband/:filter', component: Mbb, exact: true },
      { path: '/mobilbredbaand', component: Mbb, exact: true },
      { path: '/mobilbredbaand/:filter', component: Mbb, exact: true },

      { path: '/mobilt-bredbånd', component: Mbb, exact: true },
      { path: '/mobilt-bredbånd/:filter', component: Mbb, exact: true },
      { path: '/mobilt-bredband', component: Mbb, exact: true },
      { path: '/mobilt-bredband/:filter', component: Mbb, exact: true },
      { path: '/mobilt-bredbaand', component: Mbb, exact: true },
      { path: '/mobilt-bredbaand/:filter', component: Mbb, exact: true },

      { path: '/mobiltbredbånd', component: Mbb, exact: true },
      { path: '/mobiltbredbånd/:filter', component: Mbb, exact: true },
      { path: '/mobiltbredband', component: Mbb, exact: true },
      { path: '/mobiltbredband/:filter', component: Mbb, exact: true },
      { path: '/mobiltbredbaand', component: Mbb, exact: true },
      { path: '/mobiltbredbaand/:filter', component: Mbb, exact: true },

      { component: NotFound, status: 404 }
    ]
  }
];
//
// export function getRoutes(/*store*/) {
//   return (
//     <App>
//       <Switch>
//         <Route exact path="/" component={Frontpage} />
//
//         <Route exact path="/om" component={About} />
//         <Route exact path="/privacy" component={Privacy} />
//         <Route exact path="/kontakt" component={Contact} />
//         <Route exact path="/terms" component={Terms} />
//
//         <Route exact path={encodeURI('/lån')} component={loan} />
//         <Route exact path="/lan" component={loan} />
//         <Route exact path="/laan" component={loan} />
//
//         <Route
//           exact
//           path={encodeURI('/forbrugslån')}
//           component={consumerloan}
//         />
//         <Route exact path="/forbrugslaan" component={consumerloan} />
//
//         <Redirect exact from={encodeURI('/kviklån')} to={encodeURI('/lån')} />
//         <Redirect exact from="/kviklaan" to={encodeURI('/lån')} />
//         {/*
//       <Route path={encodeURI('kviklån')} component={ quickloan } />
//       <Route path='kviklaan' component={ quickloan } />
//     */}
//
//         <Route exact path="/a-kasse" component={Akasse} />
//         <Route exact path="/akasse" component={Akasse} />
//
//         <Route exact path={encodeURI('/bredbånd')} component={Broadband} />
//         <Route exact path="/bredband" component={Broadband} />
//         <Route exact path="/bredbaand" component={Broadband} />
//
//         <Route
//           exact
//           path="/mobilabonnement"
//           component={CellphoneSubscription}
//         />
//         <Route exact path="/taletidskort" component={CellphonePrepaid} />
//
//         <Route exact path="/tv-udbydere" component={Tv} />
//
//         <Route exact path={encodeURI('/mobil-bredbånd')} component={Mbb} />
//         <Route exact path={encodeURI('/mobil-bredband')} component={Mbb} />
//         <Route exact path={encodeURI('/mobil-bredbaand')} component={Mbb} />
//
//         <Route exact path={encodeURI('/mobilbredbånd')} component={Mbb} />
//         <Route exact path={encodeURI('/mobilbredband')} component={Mbb} />
//         <Route exact path={encodeURI('/mobilbredbaand')} component={Mbb} />
//
//         <Route exact path={encodeURI('/mobilt-bredbånd')} component={Mbb} />
//         <Route exact path={encodeURI('/mobilt-bredband')} component={Mbb} />
//         <Route exact path={encodeURI('/mobilt-bredbaand')} component={Mbb} />
//
//         <Route exact path={encodeURI('/mobiltbredbånd')} component={Mbb} />
//         <Route exact path={encodeURI('/mobiltbredband')} component={Mbb} />
//         <Route exact path={encodeURI('/mobiltbredbaand')} component={Mbb} />
//
//         <Route component={NotFound} status="404" />
//       </Switch>
//     </App>
//   );
// }
